import usePrice from '@commerce/product/use-price'
import type { ProductVariant } from '@commerce/types/product'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC } from 'react'

const ProductCartButtonText: FC<{
  variant?: ProductVariant
  productUnavailable?: boolean
}> = ({ variant, productUnavailable }) => {
  const { t } = useTranslation('common')

  if (productUnavailable) {
    return <div>{`${t('unavailable')}`}</div>
  }

  if (!variant) {
    return <div>{`${t('make-your-selection')}`}</div>
  }

  if (!variant.availableForSale) {
    return <div>Out of Stock</div>
  }

  return <div>{t('add-to-cart')}</div>
}

export default ProductCartButtonText
